<template>
  <info-header-card :header="card_header" :rows="card_rows">
    <template #managedList>
      <a :href="`#/managed-lists/${managedList.id}`" class="btn-link">
        {{ managedList.description }}
      </a>
    </template>
  </info-header-card>
</template>

<script>
import InfoHeaderCard from "@/components/shared/InfoHeaderCard";
export default {
  name: "AttributesListsCard",
  components: {
    InfoHeaderCard
  },
  props: {
    attribute: {
      type: Object,
      default: () => null
    },
    managed_list_options: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    managedList() {
      return this.attribute.managed_list;
    }
  },
  data() {
    return {
      card_header: null,
      card_rows: ["Managed List"]
    };
  },
  methods: {
    setComponentData() {
      if (this.attribute) {
        this.card_header = this.attribute.value;
        this.card_rows = this.formatBodyRows();
      } else {
        this.card_header = "";
      }
    },
    formatBodyRows() {
      return [
        // {
        //   label: "Name",
        //   value: this.attribute.value
        // },
        {
          label: "Managed List",
          value: this.attribute.managed_list,
          slot: "managedList"
        },
        // {
        //   label: "Managed Parent List",
        //   value: this.attribute.parent
        //     ? this.managed_list_options.find(
        //         option => option.id === this.attribute.parent.managed_list_id
        //       ).name
        //     : "Not Specified"
        // },
        // {
        //   label: "Managed Children List",
        //   value: this.attribute.children.length
        //     ? this.managed_list_options.find(
        //         option =>
        //           option.id === this.attribute.children[0].managed_list_id
        //       ).name
        //     : "Not Specified"
        // },
        // {
        //   label: "Attribute Children List",
        //   value: this.attribute.children.length
        //     ? this.attribute.children
        //         .map(child => child.value)
        //         .toString()
        //         .replaceAll(",", ", ")
        //     : "No Child Attributes"
        // }
      ];
    }
  },
  watch: {
    attribute: {
      handler() {
        this.setComponentData();
      },
      deep: true
    }
  },
  mounted() {
    this.setComponentData();
  }
};
</script>
